import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { ShopSearchSettingsPageProps } from './components/ShopSearchSettingsPageContent';

const ShopSearchSettingsPageContent = lazy(
  () => import('./components/ShopSearchSettingsPageContent'),
);

export const ShopSearchSettingsPage = wrapLazyNavigatorScreen(
  (props: ShopSearchSettingsPageProps) => {
    return <ShopSearchSettingsPageContent {...props} />;
  },
  {
    headerShown: false,
  },
);
